
<div class="breadcrumbs-wrapper" *ngIf="breadcrumbs.length">
  <ng-container *ngFor="let segment of breadcrumbs; let isFirst = first; let isLast = last">
    <div class="segment margin-right-1" [ngClass]="{
      'bold-font font-icon-color-black': isLast,
      'margin-left-1': !isFirst,
      'margin-left-0': isFirst
    }">
      <ng-container *ngIf="segment?.url && !isLast; else justLabel">
        <span [routerLink]="segment.url" [queryParams]="getQueryParamsObject(segment.queryParams)" class="link">{{ segment.label }}</span>
      </ng-container>
      <ng-template #justLabel>{{segment.label}}</ng-template>
    </div>
    <span *ngIf="!isLast">/</span>
  </ng-container>
</div>
